export function heartAnimation() {

    document.addEventListener("DOMContentLoaded", (event) => {
        if ($("body").hasClass("home-page") && $(window).width() < 768) {
            return;
        }

        setTimeout(() => {
            const heartHolder = document.getElementsByClassName("heart-animation-box");
            const canvasForStatic = document.getElementById("heart-animation-frames");
            const contextForStatic = canvasForStatic.getContext("2d");
            const filesForStatic = canvasForStatic.dataset.directoryUrl;
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animation = setInterval(staticImageAnimation, 30);
                    } else {
                        clearInterval(animation);
                    }
                });
            });
            let animation;
        
            canvasForStatic.width = 332;
            canvasForStatic.height = 362;
        
            const currentFrameForStatic = index => (`${filesForStatic}${index.toString().padStart(5, "0")}.webp`);
            const frameCountForStatic = 121;
            const imagesForStatic = [];
        
            const preloadimagesForScrollForStatic = () => {
                for (let i = 1; i <= frameCountForStatic; i++) {
                    imagesForStatic[i] = new Image();
                    imagesForStatic[i].src = currentFrameForStatic(i);
                }
            };
            preloadimagesForScrollForStatic();

            const imgForStatic = new Image();
            imgForStatic.src = currentFrameForStatic(1);
            imgForStatic.onload = function () {
                contextForStatic.drawImage(imgForStatic, 0, 0);
            };

            let frameIndexStatic = 0;

            function staticImageAnimation() {
                if (frameIndexStatic >= frameCountForStatic - 1) {
                    frameIndexStatic = 1;
                }

                frameIndexStatic++;
                requestAnimationFrame(() => {
                    contextForStatic.clearRect(0, 0, canvasForStatic.width, canvasForStatic.height);
                    contextForStatic.drawImage(imagesForStatic[frameIndexStatic], 0, 0);
                });
            }

            for (let i = 0; i < heartHolder.length; i++) {
                observer.observe(heartHolder[i]);
            }
        }, 2500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heartAnimation.js